import Header from '../components/header';
import '../css/index.scss';
import '../css/services/services.scss';

import { initServicesPage } from '../js/services/page';

new Header();
initServicesPage();
